exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.feature-image-wrapper[data-v-e9bc80fe] {\n  max-width: 1280px;\n  width: 100%;\n}\n.feature-image[data-v-e9bc80fe] {\n  -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n          box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n  -o-object-fit: contain;\n     object-fit: contain;\n}\n.odd-card[data-v-e9bc80fe] {\n  text-align: right;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e9bc80fe","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LP/atoms/FeatureImage.vue
// module id = gSYQ
// module chunks = 0